import styled from "styled-components";

export const StyledTextError = styled.div`
  color: #ff3d3d;
  width: 404px;
  text-align: right;
  font-family: Peyda;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  text-align: right;
  margin-top: 7px;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  width: 100%;
`;
